import React from 'react'

const PageLoader = () => {
    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",      
        backdropFilter: "blur(2px)",         
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999 
    }
    const loaderStyle = {
        height: 80,
        width: 80,
        borderWidth: 8
    }
    return (
        <div 
            style={overlayStyle}
        >
            <div 
                className="spinner-border text-danger"
                style={loaderStyle}
            >
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}
export default PageLoader